import { useSyncExternalStore } from 'react'

// Last-dialed number, shared across BLF / contacts / footer / dial pad so Redial works no
// matter where the call was placed. In-memory only.
let last = ''
const listeners = new Set<() => void>()

export const getLastDialed = (): string => last
export function setLastDialed(n: string): void {
  last = n
  for (const l of listeners) l()
}
const subscribe = (cb: () => void): (() => void) => { listeners.add(cb); return () => listeners.delete(cb) }
export const useLastDialed = (): string => useSyncExternalStore(subscribe, getLastDialed, getLastDialed)
